import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { AddButton, DBRadioButton } from '_components';
import { OutMeasureEntry } from './OutMeasureEntry';
import { CommonButton } from '_components';
import { patientActions } from '_actions';
import { faRefresh, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class PatientCareCenterNoteObjectiveOutMeasures extends React.Component {

    addOutcome() {
        this.props.addChildRow(this.props.noteId, 'PTOUTMEASURES', 'OM', 'OM' + this.props.prefix + 'NO', this.props.pk);
        if (this.props.outReason) {
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'OBJNOOUTCOMEREASON');
        }
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    refreshOutcomes() {
        this.props.refreshFotoEpisodes(this.props.epno, this.props.noteId);
        this.props.getLimberOutcomes(this.props.epno, this.props.noteId);
    }

    objValueChanged() {
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='obj_outmeasures' name='Outcome Measures' level={5} refProp={this.props.outcomesRef} className={this.props.noteType === 4 ? "" : styles.required}>
                <CommonButton className={styles.refresh_button} size='smaller' title='Refresh Assessment Information' onClick={() => this.props.fotoRefresh ? null : this.refreshOutcomes()} ><FontAwesomeIcon icon={faRefresh} color="white" className={this.props.fotoRefresh ? styles.spinny : ''}></FontAwesomeIcon></CommonButton>

                {this.props.fotoActivities && this.props.fotoActivities.length > 0 &&
                    < span >
                        <div className={styles.row}>
                            <span className={styles.foto_act_header}>FOTO Activities </span>
                            <span className={styles.foto_cur_limit_header}>Current Limitation</span>
                        </div>
                        {Object.keys(this.props.fotoActivities)
                            .map(key => {
                                const result = this.props.fotoActivities[key];
                                return (
                                    <div key={result.FOTOPRNO} className={styles.row}>
                                        <span title={result.PRQUESTION} className={styles.foto_act}>{result.PRQUESTION}</span>
                                        <span className={styles.foto_cur_limit}>{result.PRRESPONSE}</span>
                                    </div>
                                )
                            })
                        }
                    </span>
                }

                {this.props.limberOutcomesLoading &&
                    <span>
                        <div className={styles.row}>
                            <span className={styles.foto_act_header}>Refreshing Limber Assessment Questionnaires... </span>
                            <FontAwesomeIcon icon={faSpinner} pulse color="#717271" style={{ marginLeft: '10px' }} />
                        </div>
                    </span>
                }

                {this.props.limberOutcomes && this.props.limberOutcomes.length > 0 && !this.props.limberOutcomesLoading &&
                    <span>
                        <div className={styles.row}>
                            <span className={styles.foto_act_header}>Limber Assessment Questionnaires </span>
                        </div>
                        {Object.keys(this.props.limberOutcomes)
                            .map(key => {
                                const result = this.props.limberOutcomes[key];
                                const omDate = result.OMDATE ? new Date(result.OMDATE).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '';
                                return (
                                    <div key={result.OMNO} className={styles.row}>
                                        <span className={styles.limber_spacer}></span>
                                        <span className={styles.limber_date}>{omDate}</span>
                                        <span> </span>
                                        <span title={result.OMNAME} className={styles.limber_title}>{result.OMNAME + " - " + result.OMSCORE}   </span>
                                    </div>
                                );

                            })}

                    </span>
                }

                {this.props.outMeasures.length === 0 && this.props.limberOutcomes.length === 0 &&
                    <div>
                        <div className={styles.row}>
                            <DBRadioButton
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'OBJNOOUTCOMEREASON'}
                                label='Outcome measure to be administered at a future date'
                                selectedValue='Outcome measure to be administered at a future date'
                                onClick={() => this.objValueChanged()}
                            />
                        </div>
                        <div className={styles.row}>
                            <DBRadioButton
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'OBJNOOUTCOMEREASON'}
                                label='No outcome tool appropriate for this patient scenario'
                                selectedValue='No outcome tool appropriate for this patient scenario'
                                onClick={() => this.objValueChanged()}
                            />
                        </div>
                    </div>
                }

                <div className={styles.row}>
                    <span className={styles.add_button}>
                        <AddButton title='Add Outcome Measure...' size='extra-small' onClick={() => this.addOutcome()} />
                    </span>
                    <span className={this.props.outcomeReq ? styles.out_measure_header : styles.out_measure_header_not_req}>Outcome Measure</span>
                    <span className={styles.date_header}>Date</span>
                    {!this.props.isPeds &&
                        <span className={this.props.outcomeReq ? styles.score_header : styles.score_header_not_req}>Score</span>
                    }
                </div>
                {
                    Object.keys(this.props.outMeasures)
                        .map(key => {
                            const result = this.props.outMeasures[key];
                            return (
                                <OutMeasureEntry key={result.OMNO} id={result.OMNO} epno={this.props.epno} />
                            )
                        })
                }

            </PatientCareCenterNoteSection >
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        refreshFotoEpisodes: bindActionCreators(patientActions.refreshFotoEpisodes, dispatch),
        getLimberOutcomes: bindActionCreators(noteActions.getLimberOutcomes, dispatch),

    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let prefix = noteType === 1 ? 'EV' : 'NT';
    let table = noteType === 1 ? 'PTEVAL' : 'PTNOTE';
    let outReason = state.entities.notes[table][pk][prefix + 'OBJNOOUTCOMEREASON'];
    let outMeasures = Object.keys(state.entities.notes.PTOUTMEASURES)
        .filter(key => {
            return (((noteType === 1 && state.entities.notes.PTOUTMEASURES[key].OMEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTOUTMEASURES[key].OMNTNO === pk)) && state.entities.notes.PTOUTMEASURES[key].OMLIMBERQUESTID === null)
        })
        .sort((a, b) => state.entities.notes.PTOUTMEASURES[a].OMNO - state.entities.notes.PTOUTMEASURES[b].OMNO)
        .map(key => state.entities.notes.PTOUTMEASURES[key]);

    let limberOutcomes = Object.keys(state.entities.notes.PTOUTMEASURES)
        .filter(key => {
            return (((noteType === 1 && state.entities.notes.PTOUTMEASURES[key].OMEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTOUTMEASURES[key].OMNTNO === pk))
                && state.entities.notes.PTOUTMEASURES[key].OMLIMBERQUESTID !== null
                && state.entities.notes.PTOUTMEASURES[key].OMSCORE !== null)
                && state.entities.notes.PTOUTMEASURES[key].OMNAME !== "Net Promoter Score (NPS)";
        })
        .sort((a, b) => state.entities.notes.PTOUTMEASURES[a].OMNO - state.entities.notes.PTOUTMEASURES[b].OMNO)
        .map(key => state.entities.notes.PTOUTMEASURES[key]);

    let fotoActivities = Object.keys(state.entities.notes.FOTOPATIENTRESPONSE)
        .filter(key => {
            return (noteType === 1 && state.entities.notes.FOTOPATIENTRESPONSE[key].PREVNO === pk) ||
                (noteType !== 1 && state.entities.notes.FOTOPATIENTRESPONSE[key].PRNTNO === pk)
        })
        .sort((a, b) => state.entities.notes.FOTOPATIENTRESPONSE[a].FOTOPRNO - state.entities.notes.FOTOPATIENTRESPONSE[b].FOTOPRNO)
        .map(key => state.entities.notes.FOTOPATIENTRESPONSE[key]);
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;

    let epno = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTEPNO : state.entities.notes.PTEVAL[pk].EVEPNO;
    let fotoRefresh = state.ui.admissions[epno].fotoRefreshing;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled;
    let limberOutcomesLoading = state.ui.notes[noteId]?.limberOutcomesLoading || false;

    let outcomeReq = true;

    if (noteType === 4) {
        outcomeReq = false;
    }

    if (noteType === 2) {
        outcomeReq = false;
    }

    return {
        noteId,
        noteType,
        pk,
        table,
        prefix,
        outReason,
        outMeasures,
        fotoActivities,
        objUpdated,
        fotoRefresh,
        epno,
        isPeds,
        outcomeReq,
        limberOutcomes,
        limberOutcomesLoading
    };
}

const connectedPatientCareCenterNoteObjectiveOutMeasures = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveOutMeasures);
export { connectedPatientCareCenterNoteObjectiveOutMeasures as PatientCareCenterNoteObjectiveOutMeasures };

